/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var selectDefaultProps = {
  autoWidth: false,
  autofocus: false,
  borderless: false,
  clearable: false,
  creatable: false,
  loading: false,
  max: 0,
  minCollapsedNum: 0,
  multiple: false,
  placeholder: void 0,
  readonly: false,
  reserveKeyword: false,
  showArrow: true,
  size: "medium",
  status: "default",
  valueType: "value"
};
var optionDefaultProps = {
  checkAll: false,
  disabled: false
};
var optionGroupDefaultProps = {
  divider: true
};

export { optionDefaultProps, optionGroupDefaultProps, selectDefaultProps };
//# sourceMappingURL=defaultProps.js.map
